export default __webpack_public_path__ + "8fb9001abe450b1f457e16fffcf4a0a5.jpg";